const state = () => ({
  dataHistory: [],
  totalData: 0,
  totalPage: 0,
  loading: false,
  onDownloadResult: false,
  onUpload: false,
  uploadProgress: 0,
  flashErrorMessage: '',
  flashError: false,
});

export default state;
